import { Component } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';
import { PageService } from 'src/app/services/page.service';
import { CommonService } from 'src/app/services/common_service/common.service';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})

export class AppLayoutComponent {
  pageConfig: any = this.pageService.config;
  globalData;
  userDetails;
  destroySubject$: Subject<void> = new Subject();
  authObject: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private pageService: PageService,
    private commonService: CommonService
  ) {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute.snapshot),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((route: ActivatedRouteSnapshot) => {
        const routeData = route.data;
        const routeParams = route.params;
        const queryParams = route.queryParams;
        this.pageService.init({ routeData, routeParams, queryParams });
      });
  }

  ngOnInit() {
    if (this.pageConfig.pageName !== "errorCodeLookup" && this.pageConfig.pageName !== "cmsAdmin" && this.pageConfig.pageName !== "authorizationError" && this.pageConfig.pageName !== "logoutPage") {
      this.commonService.getDocTypes();
    }
  }

  ngOnDestroy() {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

}
